export const CV_EDITOR_PATH = '/resume/new';

export const needsFreeOnboarding = (usage = {}) => usage.email_verified === true && usage.has_active_subscription === false && usage.onboarding_completed === false;

// An onboarding exemption, not an authentication or AI entitlement.
export const isManualResumePath = (path) => path === CV_EDITOR_PATH || /^\/resume\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(path);

export function resolveOnboardingGate({ needsVerify, needsOnboarding, path, verifyAllowed = false, onboardingAllowed = false }) {
  if (needsVerify && !verifyAllowed) return 'verify';
  if (needsOnboarding && !onboardingAllowed && !isManualResumePath(path)) return 'pricing';
  return 'allow';
}

// One useful next step, based on actual entries rather than a hiring prediction.
export function nextResumeStep(content = {}, saved = false) {
  const personal = content.personal_info || {};
  const step = (label, action, target) => ({ label, action, target });
  if (!personal.full_name?.trim()) return step('Add the name recruiters should see.', 'Add name', 'input-fullname');
  if (!personal.email?.trim()) return step('Add a contact email.', 'Add email', 'input-email');
  if (!personal.phone?.trim()) return step('Add a phone number.', 'Add phone', 'input-phone');
  const hasRole = (content.experiences || []).some(entry => entry.position?.trim() || entry.company?.trim() || entry.description?.trim());
  const hasProject = (content.projects || []).some(entry => entry.name?.trim() || entry.description?.trim());
  if (!hasRole && !hasProject) return step('Add a role or project. Either is a good start.', 'Add experience', 'background-section-mode');
  if (!(content.education || []).some(entry => entry.institution?.trim() || entry.degree?.trim())) return step('Add your education or training.', 'Add education', 'section-education');
  if (!(content.skills || []).some(skill => skill.name?.trim() || (skill.items || []).some(item => String(item).trim()))) return step('Add skills relevant to your next role.', 'Add skills', 'section-skills');
  if (!personal.summary?.trim()) return step('Introduce yourself in 2–3 sentences. You can type or dictate.', 'Add summary', 'input-summary');
  return saved ? step('Check your layout before applying.', 'Preview CV', 'preview') : step('Save your CV to enable PDF download.', 'Save CV', 'save');
}
